import moment from "moment";
import React from "react";

export const VendorsTableHeaderData = (t) =>
  [
  {
    id: 1,
    label: "vendor-name",
    input: "vendor_name.name",
    searchableKey: "vendor_name.name",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.name || ""}</div>,
  },
  {
    id: 2,
    label: "vendor-category",
    input: "vendorCategory",
    searchableKey: "vendorCategory",
    isSortable: true,
    isHiddenFilter: false,
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.vendor_category || ""}</div>,
    fieldType: "select",
    data: {
      lookupName: "VendorCategory",
    },
  },
  {
    id: 3,
    label: "vendor-class",
    input: "vendorClass",
    searchableKey: "vendorClass",
    isSortable: true,
    isHiddenFilter: true ,
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.vendorClass || ""}</div>,
    fieldType: "select",
    data: {
      lookupName: "VendorClass",
    },
  },

  {
    id: 4,
    label: "created-by",
    input: "createdBy",
    isHiddenFilter: false,
    fieldType: "searchField",
    fieldKey: "createdBy",
    isDefaultFilterColumn: true,
    isSortable: true,
    data: {
      type: "string",
      title: "Created By",
      description: "General Information",
      searchKey: "User",
      iconField: "",
      dependOn: "",
      multi: "false",
      default: "",
      isSearchable: false,
      searchableKey: "createdBy",
      displayPath: "createdBy",
    },
  },
  {
    id: 5,
    label: "creation-on",
    input: "createdOn",
    isHiddenFilter: false,
    fieldKey: "CreatedOn",
    displayPath: "CreatedOn",
    fieldType: "alt-date",
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    component: (item) => (
      <div>
        {(item?.createdDate &&
          moment(item?.createdDate).format("DD/MM/YYYY - hh:mm A")) ||
          ""}
      </div>
    ),
  },

  {
    id: 6,
    label: "update-on",
    input: "updateOn",
    isHiddenFilter: false,
    fieldType: "alt-date",
    fieldKey: "updateOn",
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    component: (item) => (
      <div>
        {(item?.lastUpdatedDate &&
          moment(item?.lastUpdatedDate).format("DD/MM/YYYY - hh:mm A")) ||
          ""}
      </div>
    ),
  },
  {
    id: 7,
    label: "updated-by",
    input: "updatedBy",
    isHiddenFilter: false,
    fieldType: "searchField",
    fieldKey: "updatedBy",
    isDefaultFilterColumn: true,
    isSortable: true,
    data: {
      type: "string",
      title: "Updated By",
      description: "General Information",
      searchKey: "User",
      iconField: "",
      dependOn: "",
      multi: "false",
      default: "",
      isSearchable: false,
      searchableKey: "updatedBy",
      displayPath: "updatedBy",
    },
  },
  {
    id: 8,
    label: "email",
    isHiddenFilter: false,
    isDefaultFilterColumn: true,
    input: "vendor_email.email",
    fieldType: "text",
    isSortable: true,
    data: {
      type: "string",
      title: "Email Address",
      description: "Main Information",
      CommunicationType: "Email",
      duplicateValidation: "true",
      iconField: "",
      regExp: "^(?:[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+|\\*{8})$",
      errorMsg: "Fill Email in a correct way",
      isSearchable: true,
      searchableKey: "email_address",
      displayPath: "vendor_email",
      DtoName: "",
      HelperInfo: "",
      sensitive: true,
      caption: "",
    },
    component: (item) => (
      <div>{(item?.vendorEmail) || ""}</div>
    ),
  },
  {
    id: 9,
    label: "Contact Number",
    input: "landline_number.phone",
    searchableKey: "landline_number.phone",
    data: {
      type: "string",
      title: "Contact Number",
      description: "Main Information",
      CommunicationType: "Phone",
      duplicateValidation: "true",
      iconField: "",
      regExp: "^(?:[0-9]+|\*{8})$",
      errorMsg: "Fill landline number in a correct way",
      isSearchable: true,
      searchableKey: "landline_number.phone",
      displayPath: "landline_number.phone",
      DtoName: "",
      HelperInfo: "",
      sensitive: true,
      caption: "Contact Number" ,
    },
    isSortable: true,
    isHiddenFilter: false,
    fieldType : "phone",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.landline_number?.phone) || ""}</div>
    ),
  },
  {
    id: 10,
    label: "agreement-status",
    isSortable: true,
    fieldKey: "agreementStatus",
    input: "agreementStatus",
    displayPath: "agreementStatus",
    isDefaultFilterColumn: true,
    isHiddenFilter: false,
    fieldType: "text",
    component: (item) => <div>{item?.agreementStatusName || ""}</div>,
    fieldType: "select",
    data: {
      lookupName: "VendorAgreementStatus",
    },

  },
  {
    id: 11,
    label: "PSI-key-person",
    input: "psi_key_person.name",
    isSortable: true,
    searchableKey: "psi_key_person.name",
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.psi_key_person && item.psi_key_person.name) || ""}</div>
    ),
    fieldType: "searchField",
    data: {
      type: "string",
      title: "PSI-key-person",
      searchKey: "User",
      iconField: "",
      dependOn: "",
      multi: "false",
      default: "",
      isSearchable: false,
      searchableKey: "psi_key_person.name",
      displayPath: "psi_key_person.name",

    },

  },
  {
    id: 12,
    label: "number-of-offers",
    input: "numberOfOffers",
    isSortable: true,
    searchableKey: "numberOfOffers",
    isHiddenFilter: false,
    fieldType: "number",
    isDefaultFilterColumn: true,
    isNumber: true,
    textInputMin: 0,
    component: (item) => <div>{item?.numberOfOffers || ""}</div>,
  },
  {
    id: 13,
    label: "last-activity-name",
    input: "lastActivityName",
    isSortable: true,
    searchableKey: "lastActivityName",
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.lastActivityName || ""}</div>,
  },
  {
    id: 14,
    label: "activity-date",
    input: "activityDate",
    isHiddenFilter: false,
    fieldType: "alt-date",
    fieldKey: "activityDate",
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    component: (item) => (
      <div>
        {(item?.lastActivityDate &&
          moment(item?.lastActivityDate).format("DD/MM/YYYY hh:mm A")) ||
          ""}
      </div>
    ),
  },
  {
    id: 15,
    label: "activity-created-by",
    input: "activityCreatedBy",
    fieldKey: "activityCreatedBy",
    isSortable: true,
    searchableKey: "activityCreatedBy",
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.lastActivityCreatedBy || ""}</div>,
  },
  {
    id: 16,
    label: "agreement-start-date",
    input: "agreementStartDate",
    isHiddenFilter: false,
    fieldType: "alt-date",
    fieldKey: "agreementStartDate",
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    fieldType: "alt-date",
    component: (item) => (
      <div>
        {(item?.contractStartDate &&
          moment(item?.contractStartDate).format("DD/MM/YYYY - hh:mm A")) ||
          ""}
      </div>
    ),
  },
  {
    id: 17,
    label: "agreement-expiry-date",
    input: "agreementExpiryDate",
    isHiddenFilter: false,
    fieldType: "alt-date",
    fieldKey: "agreementExpiryDate",
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    fieldType: "alt-date",
    component: (item) => (
      <div>
        {(item?.contractExpiryDate &&
          moment(item?.contractExpiryDate).format("DD/MM/YYYY - hh:mm A")) ||
          ""}
      </div>
    ),
  },
  {
    id: 18,
    label: "website-url",
    input: "website_url",
    isSortable: true,
    searchableKey: "website_url",
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.website_url && item.website_url) || ""}</div>
    ),
  },
  {
    id: 19,
    label: "country",
    input: "country.lookupItemName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.country && item.country.lookupItemName) || ""}</div>
    ),
    fieldType: "select",
    data: {
      lookup: 16 ,
    },
  },
  {
    id: 20,
    label: "city",
    input: "city.lookupItemName",
    isSortable: true,
    isHiddenFilter: false,
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.city && item.city.lookupItemName) || ""}</div>
    ),
    fieldType: "select",
    data: {
      lookup: 17 ,
    },
  },

  {
    id: 21,
    label: "district",
    input: "district.lookupItemName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.district && item.district.lookupItemName) || ""}</div>
    ),
    fieldType: "select",
    data: {
      lookup: 18 ,
    },
  },
  {
    id: 22,
    label: "community",
    input: "community.lookupItemName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>{(item?.community && item.community.lookupItemName) || ""}</div>
    ),
    fieldType: "select",
    data: {
      lookup: 19 , 
    },
  },
  {
    id: 23,
    label: "sub-community",
    input: "sub_community.lookupItemName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => (
      <div>
        {(item?.sub_community && item.sub_community.lookupItemName) || ""}
      </div>
    ),
    fieldType: "select",
    data: {
      lookup:20 ,
    },
  },
  {
    id: 24,
    label: "Company Name",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    searchableKey: "companyName",
    component: (item) => item?.holding_company?.name,
  },
];
